import { render, staticRenderFns } from "./stock-list-page.vue?vue&type=template&id=2327ba78&"
import script from "./stock-list-page.vue?vue&type=script&lang=ts&"
export * from "./stock-list-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports